import { Button } from 'ui/mobile-ds';
import { CatInBox, CopyIcon } from 'ui/icons';
import { PLUM__EMAILS } from '@/constants';
import { useAppContext } from '@/context/AppContext';
import toast from 'react-hot-toast';

interface IProps {
  title: string;
  subtitle: string;
  cta: string;
  handleCtaClick: () => void;
  email?: string;
}

const AddFamilyMemberErrorScreen = ({
  title,
  subtitle,
  cta,
  handleCtaClick,
  email,
}: IProps) => {
  const { isWebView } = useAppContext();
  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(PLUM__EMAILS.CARE_ID);
    if (isWebView) {
      window?.NativeBridge?.onTextCopy?.(PLUM__EMAILS.CARE_ID);
    } else {
      await navigator.clipboard.writeText(PLUM__EMAILS.CARE_ID);
    }

    toast.success('Email id copied');
  };
  return (
    <div className="flex items-center justify-center h-[100%]">
      <div className="flex flex-col items-center justify-center gap-4">
        <CatInBox height={120} width={120} />
        <div className="flex flex-col items-center gap-2">
          <p className=" text-mobile-text-main font-black text-[22px] font-chromatica text-center">
            {title}
          </p>
          <p className="text-sm md:text-base text-gray-400 flex flex-col md:flex-row gap-1 text-center">
            {subtitle}
            {email && (
              <p className="text-mobile-hero-100">
                <Button
                  intent="tertiary"
                  className="min-w-0 h-auto font-normal gap-1"
                  onClick={copyToClipboard}
                >
                  {email}
                  <CopyIcon fill="#EE4F5E" />
                </Button>
              </p>
            )}
          </p>
        </div>
        <Button
          className="px-10 py-[14px] text-base font-body font-medium"
          intent={email ? 'secondary' : 'primary'}
          onClick={handleCtaClick}
        >
          {cta}
        </Button>
      </div>
    </div>
  );
};

export default AddFamilyMemberErrorScreen;
